import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";

export default createVuetify({
  components,
  directives,
  // Vuetify's default (`lg`, 1280px) calls a laptop "mobile", which puts the
  // phone-only UI on desktops. `md` lines $vuetify.display.mobile up with the
  // d-md-* utility classes the app bar already uses.
  display: {
    mobileBreakpoint: "md",
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  // Defaults on the kit: sentence-case buttons, the system font (tokens.css),
  // dialogs and menus on the sheet colour and radius.
  defaults: {
    VBtn: { style: "text-transform: none; letter-spacing: 0;" },
    VCard: { rounded: "lg" },
    VDialog: { scrim: "rgba(0, 0, 0, 0.55)" },
  },
  // Theme colours are the token values in src/styles/tokens.css (the app's
  // CL class). Vuetify needs literal hex here, so they're repeated.
  theme: {
    defaultTheme: "dark",
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#a855f7",
          secondary: "#8b3fe0",
          accent: "#a855f7",
          error: "#ff453a",
          info: "#3b82f6",
          success: "#30d158",
          warning: "#ffb020",
          background: "#f5f5f7",
          surface: "#ffffff",
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: "#a855f7",
          secondary: "#c08bff",
          accent: "#a855f7",
          error: "#ff453a",
          info: "#3b82f6",
          success: "#30d158",
          warning: "#ffb020",
          background: "#0a0a0f",
          surface: "#1c1c24",
          "surface-variant": "#26262f",
          // Tooltips draw on-surface-variant on surface-variant. Vuetify's
          // dark default (#424242) is for its light-gray surface-variant, so
          // with ours it was dark on dark.
          "on-surface-variant": "#f5f5f7",
          "on-surface": "#f5f5f7",
          "on-background": "#f5f5f7",
        },
      },
    },
  },
});
